var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alert alert-info fade show text-center",attrs:{"role":"alert"}},[_c('i',{staticClass:"fas me-2",class:_vm.icon}),_vm._v(" "),(_vm.title)?_c('strong',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }